import React from 'react';
import ReactMarkdown from 'react-markdown';
import styles from './RecommendationCards.module.css';

const RecommendationCards = ({ recommendations = [] }) => {
  // Sort recommendations by rank (ascending)
  const sortedRecommendations = [...recommendations].sort((a, b) => (a.rank || 0) - (b.rank || 0));
  const basePath = process.env.PUBLIC_URL || '';
  const cardCount = sortedRecommendations.length;

  const getGridClass = () => {
    if (cardCount === 1) return styles.recommendationGridSingle;
    if (cardCount === 2) return styles.recommendationGridDouble;
    return styles.recommendationGrid;
  };

  return (
    <div className={styles.recommendationSection}>
      <div className={styles.recommendationHeader}>
        <div className={styles.recommendationTag}>Recommended Decision Paths</div>
      </div>

      <div className={getGridClass()}>
        {sortedRecommendations.map((rec,index) => {
          console.log(rec)
          const isAI = rec.primary === 1;
          const badgeText = rec.recommendedBadgeText || 'AI Recommended';
          const descriptionContent = rec.description || rec.markdown || 'xsacsasacac';
          
          return (
            <div key={index} className={isAI ? styles.recommendationCardAI : styles.recommendationCardNormal}>
              {isAI && (
                <div className={styles.aiRecommendedBadge}>
            <img src={`${basePath}/assets/images/workbench/ai-star-icon-white.png`} alt="star-icon" style={{ width: '24px', height: '24px' }} />
            {badgeText}
                </div>
              )}
              <div className={`${styles.recommendationContent} ${isAI ? styles.aiContentCard : ''}`}>
                <h4 className={isAI ? styles.recommendationTitleAI : styles.recommendationTitle}>
                  {rec.title}
                </h4>
                <div className={isAI ? styles.recommendationDescriptionAI : styles.recommendationDescription}>
                  <ReactMarkdown>{descriptionContent}</ReactMarkdown>
                </div>

                <div className={isAI ? styles.recommendationPayableAI : styles.recommendationPayable}>
                  <span className={isAI ? styles.recommendationPayableLabelAI : styles.recommendationPayableLabel}>
                    Payable Amount
                  </span>
                  <span className={isAI ? styles.recommendationPayableValueAI : styles.recommendationPayableValue}>
                    {rec.payableAmountText}
                  </span>
                </div>

                <div style={{ display: 'flex', justifyContent: 'center' }}>
                  <button 
                    className={isAI ? styles.submitButtonAI : styles.submitButtonNormal}
                    onClick={() => console.log('CTA Action:', rec.ctaAction)}
                  >
                    {rec.ctaText && (rec.ctaText.length > 30 || /[<|>]/.test(rec.ctaText)) 
                      ? 'View Recommendation' 
                      : rec.ctaText}
                  </button>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default RecommendationCards;
